export class HttpError extends Error {
  public status: number;

  constructor(message: string, status: number) {
    super(message);

    this.name = 'HttpError';
    this.status = status;

    // Fix prototype chain (important when targeting ES5)
    Object.setPrototypeOf(this, HttpError.prototype);
  }
}
